import axios from "axios"

const getLifetimeCheckoutLink: () => Promise<string> = async () => {
    const { data } = await axios.get(`subscriptions/lifetime-checkout-link`)
    return data
}

export default getLifetimeCheckoutLink
